import { isEmotionPropValid } from '@hcr/pwa/components'

export const isPwaPropValid = isEmotionPropValid('variant')
